// листинг в каталоге

// import { createApp } from "vue";
import { createApp } from 'vue/dist/vue.esm-bundler';
import { createPinia } from "pinia";
import { useContextStore } from '../../../../assets/site/js/contextStore.js'

var shop_carousel_init = false;
var shop_carousel;

function carouselShopPageImages(){

    let el = document.querySelector( ".store-detail__photos-wrapper.f-carousel" );

    if( el ){
        if( window.innerWidth <= 1024 ){
            if( !shop_carousel_init ){
                shop_carousel_init = true;
                shop_carousel = new Carousel(
                    el ,
                    {
                        infinite : true ,
                        Dots : {
                            maxCount : 0
                        } ,
                    }
                );
            }
        }else if( shop_carousel_init ){
            shop_carousel.destroy();
            shop_carousel_init = false;
        }
    }
}

window.addEventListener( "resize" , carouselShopPageImages );
document.addEventListener( "DOMContentLoaded" , carouselShopPageImages );
